$(document).ready(function () {
    document.querySelectorAll('.bn_dropzone__input').forEach((inputElement) => {
        const dropZoneElement = inputElement.closest('.bn_dropzone');

        dropZoneElement.addEventListener('click', () => {
            inputElement.click();
        });

        inputElement.addEventListener('change', () => {
            updateThumbnail(dropZoneElement, inputElement);
        });

        // dropZoneElement.addEventListener('dragover', (e) => {
        //     e.preventDefault();
        //     dropZoneElement.classList.add('hovered');
        // });

        // ['dragleave', 'dragend'].forEach((type) => {
        //     dropZoneElement.addEventListener(type, () => {
        //         dropZoneElement.classList.remove('hovered');
        //     });
        // });
        //
        // dropZoneElement.addEventListener('drop', (e) => {
        //     e.preventDefault();
        //
        //     if (e.dataTransfer.files.length) {
        //         inputElement.files = e.dataTransfer.files;
        //         $(inputElement).val(null)
        //         updateThumbnail(dropZoneElement, e.dataTransfer);
        //     }
        //
        //     dropZoneElement.classList.remove('hovered');
        // });
    });

    $('.bn_dropzone__form').on('afterValidateAttribute', function (event, attribute, messages) {
        let submit = $('.bn_dropzone__submit');

        if (messages.length === 0) {
            submit.removeAttr('disabled');
        } else {
            submit.attr('disabled', true);
        }
    });
})

function updateThumbnail(dropZoneElement, inputElement) {
    let prompt = dropZoneElement.querySelector('.bn_dropzone__prompt'),
        image = dropZoneElement.querySelector('.bn_dropzone__image'),
        thumb = dropZoneElement.querySelector('.bn_dropzone__thumb'),
        name = dropZoneElement.querySelector('.bn_dropzone__name');

    if (inputElement.files.length) {
        let file = inputElement.files[0];

        if (file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                let image = document.createElement('img');
                image.src = reader.result
                $(thumb).html(image);
                $(name).text(file.name)
            };

            image.classList.remove('hidden');
            prompt.classList.add('hidden');
            dropZoneElement.classList.add('active');
        } else {
            image.classList.add('hidden');
            prompt.classList.remove('hidden');
            dropZoneElement.classList.remove('active');
        }
    } else {
        image.classList.add('hidden');
        prompt.classList.remove('hidden');
        dropZoneElement.classList.remove('active');
    }
}
